import CustomButton from "../CustomButton/CustomButton";
import "./ContentFooter.scss"

interface Action {
    label: string;
    onClick: () => void;
}

interface ContentFooterProps {
    primaryAction: Action;
    secondaryAction?: Action;
}

export default function ContentFooter({ primaryAction, secondaryAction }: Readonly<ContentFooterProps>) {
    return (
        <div className="content-footer">
            {
                secondaryAction && (
                    <CustomButton
                        text={secondaryAction.label}
                        onClick={secondaryAction.onClick}
                        background="#FFF"
                        border="1px solid #2C2C2C1A"
                        width="160px"
                        height="48px"
                    />
                )
            }
            <CustomButton text={primaryAction.label} onClick={primaryAction.onClick} background="#EBA832" width="160px" height="48px" />
        </div>
    )
}